import { FC } from 'react';

import * as Styled from './pipes.styles';
import PipePuzzle from './pipe-puzzle/pipe-puzzle';

const Pipes: FC<{ }> = ({ }) => {
  const finalScore = 42;
  return (
    <Styled.Pipes>
      <Styled.StageDescription>REDIRECT E-710 FLOW &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp;  2/4</Styled.StageDescription>

      <PipePuzzle></PipePuzzle>

      <Styled.PuzzleObjective>Please adjust target storage facility</Styled.PuzzleObjective>
    </Styled.Pipes>
  );
};

export default Pipes;
